import FafLateDeclarationModal from "./FafLateDeclarationModal";
import useFafLateDeclarationPopup from "hooks/useFafLateDeclarationPopup";

// Mounted by Page on authenticated pages only.
const FafLateDeclarationPopup = () => {
  const { open, lateWeeks, close, goToDeclaration } =
    useFafLateDeclarationPopup();

  if (!open) return null;
  return (
    <FafLateDeclarationModal
      lateWeeks={lateWeeks}
      onClose={close}
      onConfirm={goToDeclaration}
    />
  );
};

export default FafLateDeclarationPopup;
